import { http } from 'services';

// Personal - Get occupied dates
export function getOccupiedDates(cbSuccess, cbError) {
  http.get(
    'personal/occupied-dates',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}


// Personal - List Programs
export function getListPrograms(params, cbSuccess, cbError) {
  http.get(
    'personal/programs',
    params,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get Program by ID
export function getProgramByID(programID, cbSuccess, cbError) {
  http.get(
    `personal/programs/${programID}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Assign Program
export function assignProgram(payload, cbSuccess, cbError) {
  http.post(
    'personal/assign-program',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Create and assign Program
export function createAndAssignProgram(payload, cbSuccess, cbError) {
  http.post(
    'personal/programs',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Update Program and assignment
export function updateAndAssignProgram(programID, payload, cbSuccess, cbError) {
  http.patch(
    `personal/programs/${programID}`,
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Unassign and delete/reset Program
export function unassignAndDeleteProgram(programID, cbSuccess, cbError) {
  http.delete(
    `personal/programs/${programID}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-program-schedule.js